import React from "react";
import { Descriptions, Typography, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

const { Title } = Typography;

export interface InfoItem {
  label: string;
  value: React.ReactNode;
}

interface InfoSectionProps {
  title: string;
  items: InfoItem[];
  onEdit?: () => void;
  bordered?: boolean;
  column?: number;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

const defaultLabelStyle: React.CSSProperties = {
  width: "33%",
  backgroundColor: "#fafafa",
  fontWeight: 400,
  color: "#000000E0",
};

const defaultContentStyle: React.CSSProperties = {
  width: "67%",
};

export default function InfoSection({
  title,
  items,
  onEdit,
  bordered = true,
  column = 1,
  style,
  labelStyle,
  contentStyle,
}: InfoSectionProps) {
  return (
    <div style={{ marginBottom: 32, ...style }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Title level={5} style={{ margin: 0, paddingLeft: 16 }}>
          {title}
        </Title>
        {onEdit && (
          <Button type="text" icon={<EditOutlined />} onClick={onEdit} />
        )}
      </div>

      <Descriptions
        bordered={bordered}
        column={column}
        size="small"
        labelStyle={{ ...defaultLabelStyle, ...labelStyle }}
        contentStyle={{ ...defaultContentStyle, ...contentStyle }}
      >
        {items.map((item) => (
          <Descriptions.Item key={item.label} label={item.label}>
            {item.value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
}
